import { render, staticRenderFns } from "./salesBillDetails.vue?vue&type=template&id=643241e6&scoped=true&"
import script from "./salesBillDetails.vue?vue&type=script&lang=js&"
export * from "./salesBillDetails.vue?vue&type=script&lang=js&"
import style0 from "./salesBillDetails.vue?vue&type=style&index=0&id=643241e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643241e6",
  null
  
)

export default component.exports